import { InjectionToken } from '@angular/core';

export interface AppConfig {
  base_url: string;
  default_tenant_id?: string;
}
export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
